import baseAxios, { AxiosInstance } from 'axios';
import qs from 'querystring';

interface CmsAxios extends AxiosInstance {
  setToken?: (token: string) => void;
}

declare global {
  interface Window {
    REACT_APP_CMS_API_HOST: string;
  }
}

export const cmsURL = window.REACT_APP_CMS_API_HOST || process.env.REACT_APP_CMS_API_HOST;

const axios: CmsAxios = baseAxios.create({
  baseURL: cmsURL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params),
});

axios.setToken = (token: string) => {
  if (token) {
    axios.defaults.headers['Authorization'] = `Bearer ${token}`;
  }
};

const { get, post, put } = axios;
export { get, post, put, axios };
